import { render, staticRenderFns } from "./List.vue?vue&type=template&id=52b63290&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52b63290')) {
      api.createRecord('52b63290', component.options)
    } else {
      api.reload('52b63290', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=52b63290&", function () {
      api.rerender('52b63290', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/User/List.vue"
export default component.exports